import { css } from "@emotion/css";
import { LabelHTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

import { margin } from "./FormText";
import { Text } from "../../../../foundations/typography/Text";

interface Props extends LabelHTMLAttributes<HTMLLabelElement> {
  isRequired?: boolean;
  optionalText?: string;
  info?: React.ReactNode;
  testID?: string;
}

export function FormLabel(props: Props) {
  const { t } = useTranslation();

  const {
    isRequired,
    optionalText,
    children,
    info,
    testID = "form-label",
    ...inputProps
  } = props;

  const optionalSuffix =
    optionalText === undefined ? t("optional") : optionalText;

  if (!children && !info) {
    return null;
  }

  return (
    <div
      className={css(
        {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        },
        margin("space-1", "bottom")
      )}
      data-testid={testID}
    >
      <div>
        <label {...inputProps}>
          <Text style="input/label">{children}</Text>
        </label>
        {!isRequired && optionalSuffix && (
          <Text className={css(margin("space-1", "left"))} style="input/helper">
            {`(${optionalSuffix})`}
          </Text>
        )}
      </div>
      {info}
    </div>
  );
}
